/**
 * Media query helpers - AWLP Design System
 * Max-width (desktop-down) convention, anchored to theme breakpoints.
 *
 * Usage in styled-components:
 *   ${media.tablet} { grid-template-columns: 1fr; }
 */

import { theme } from './theme';

export const media = {
  /** <= 768px — portrait tablets and below */
  tablet: `@media (max-width: ${theme.breakpoints.tablet})`,
  /** <= 1024px — landscape tablets and below */
  desktop: `@media (max-width: ${theme.breakpoints.desktop})`,
  /** <= 1440px */
  wide: `@media (max-width: ${theme.breakpoints.wide})`,
} as const;
